var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.643 3.588C15.246 2.478 12.11 3.522 11 5.914 9.89 3.522 6.754 2.477 4.356 3.588c-2.553 1.185-3.774 4.21-1.757 7.78 1.33 2.36 3.616 4.178 7.484 7.174.54.419 1.294.419 1.834 0 3.868-2.996 6.154-4.816 7.484-7.174 2.018-3.57.797-6.595-1.758-7.78z","fill":"#4541E3"}));
}

Heart.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
